/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from 'react';

export function CookieConsentManager() {
  useEffect(() => {
    // Load cookie consent scripts asynchronously without blocking app initialization
    const loadCookieConsent = async () => {
      try {
        // Check if already loaded
        if (document.getElementById('usercentrics-cmp')) {
          return;
        }

        // --- Preconnect ---
        const preconnect = document.createElement('link');
        preconnect.rel = 'preconnect';
        preconnect.href = '//privacy-proxy.usercentrics.eu';
        document.head.appendChild(preconnect);

        // Note: We intentionally do NOT load the uc-block bundle to avoid autoblocking.

        // --- Usercentrics main script ---
        const usercentrics = document.createElement('script');
        usercentrics.id = 'usercentrics-cmp';
        usercentrics.src =
          'https://app.usercentrics.eu/browser-ui/latest/loader.js';
        usercentrics.async = true;
        usercentrics.setAttribute('data-settings-id', 'UVxE_YI9Buw5AH');
        usercentrics.onerror = () => {
          // eslint-disable-next-line no-console
          console.warn('Failed to load Usercentrics main script');
        };
        document.head.appendChild(usercentrics);

        // --- Translation setup ---
        const translationScript = document.createElement('script');
        translationScript.innerHTML = `
          function setTranslations() {
            try {
              if (window.uc && typeof uc.setCustomTranslations === 'function') {
                uc.setCustomTranslations('https://termageddon.ams3.cdn.digitaloceanspaces.com/translations/');
              }
            } catch (error) {
              // eslint-disable-next-line no-console
              console.warn('Failed to set Usercentrics translations:', error);
            }
          }
          if (window.uc) {
            setTranslations();
          } else {
            window.addEventListener('UC_UI_INITIALIZED', setTranslations);
          }
        `;
        document.body.appendChild(translationScript);

        // Store references for cleanup
        (window as any).__cookieConsentElements = [
          preconnect,
          usercentrics,
          translationScript,
        ];
      } catch (error) {
        // eslint-disable-next-line no-console
        console.warn('Failed to initialize cookie consent:', error);
      }
    };

    // Load cookie consent after a short delay to ensure app initialization is not blocked
    const timeoutId = setTimeout(loadCookieConsent, 2000);

    // --- Cleanup when component unmounts ---
    return () => {
      clearTimeout(timeoutId);
      const elements = (window as any).__cookieConsentElements;
      if (elements && Array.isArray(elements)) {
        elements.forEach((el: Element) => {
          try {
            el.remove();
          } catch (error) {
            // eslint-disable-next-line no-console
            console.warn('Failed to remove cookie consent element:', error);
          }
        });
        delete (window as any).__cookieConsentElements;
      }
    };
  }, []);

  return null; // No visible UI
}
